import { Link } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";

export function LandingFooter() {
  return (
    <footer className="bg-clay-brown text-cream py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <Link to={ROUTES.HOME}>
                <img
                  src="/assets/images/logo.png"
                  alt="麻薏 Mayi AI Logo"
                  className="w-10 h-10"
                />
              </Link>
              <span className="text-xl font-semibold handwriting">
                麻薏 Mayi AI
              </span>
            </div>
            <p className="text-cream/80 leading-relaxed mb-4">
              來自台中的智慧營運助理，用在地的溫度與智慧，陪伴中小企業走向數位轉型。
            </p>
            <div className="bg-earth-green/20 rounded-lg p-3">
              <a
                className="text-sm text-cream/90"
                href="https://corp.mediatek.tw/genius-for-home/news/%E7%AC%AC%E5%85%AB%E5%B1%86%E6%99%BA%E5%9C%A8%E5%AE%B6%E9%84%89-%E5%BD%B1%E9%9F%BF%E5%8A%9B%E5%8A%A0%E9%80%9F%E8%A8%88%E7%95%AB%E9%96%8B%E8%B7%91-%E6%AD%A1%E8%BF%8E%E6%9C%89%E6%99%BA%E4%B9%8B%E5%A3%AB%E5%A0%B1%E5%90%8D%E5%8F%83%E8%88%87"
              >
                參與 MediaTek 智在家鄉 2025 計畫
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 handwriting">服務內容</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#features"
                  className="text-cream/70 hover:text-cream transition-colors"
                >
                  智慧分析建議
                </a>
              </li>
              <li>
                <a
                  href="#features"
                  className="text-cream/70 hover:text-cream transition-colors"
                >
                  在地化貼心服務
                </a>
              </li>
              <li>
                <a
                  href="#features"
                  className="text-cream/70 hover:text-cream transition-colors"
                >
                  簡單易懂操作
                </a>
              </li>
              <li>
                <Link
                  to={ROUTES.LOGIN}
                  className="text-cream/70 hover:text-cream transition-colors"
                >
                  開始使用
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 handwriting">服務條款</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to={ROUTES.TERMS}
                  className="text-cream/70 hover:text-cream transition-colors"
                >
                  使用條款
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTES.PRIVACY}
                  className="text-cream/70 hover:text-cream transition-colors"
                >
                  隱私保護
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cream/20 mt-8 pt-8 text-center">
          <p className="text-cream/60 text-sm handwriting">
            © 2025 麻薏 Mayi AI. 台中在地服務 | 用心陪伴每一家企業成長
          </p>
        </div>
      </div>
    </footer>
  );
}
